import chalk from "chalk";

export class CustomError extends Error {
  constructor(message: string, name?: string) {
    super(message);
    const startSeparator = new Array(
      message.length - ((name?.length ?? NaN) + 2 || 10),
    )
      .fill("-")
      .join("");
    const endSeparator = new Array(message.length + 3).fill("-").join("");
    this.name = chalk.black.bgMagenta.bold(`⛔  ${this.name}`);
    this.message = chalk.magenta.bold(
      startSeparator + "\n" + message + "  |" + "\n" + endSeparator,
    );
  }
}
